import React, { useState, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  FormGroup,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import {  injectIntl } from "react-intl";

import TypeRow from "../../../components/scheduleRows/typerow";
import ArchiveHeader from "../../../components/ArchiveHeader";
import PageLoading from "../../../components/Loading";

import Alert from "react-s-alert";
import { useQuery, useMutation, queryCache } from "react-query";

import { getSchedule, deleteSchedule } from '../schedules/xhr';

import CreateItemForm from '../../../components/CreateItemForm';
import Table from '../../../components/TableNew';

const Types = ({ intl, locale, setLocale }) => {
  const [search, setSearch] = useState("");
  const [typeName, setTypeName] = useState('')

  const { isLoading, isError, error, data: schedule } = useQuery('schedule', getSchedule, {
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  const [deleteTypeMutation] = useMutation(deleteSchedule, {
    onSuccess: (deletedType) => {
      if(queryCache.getQueryData('schedule')) {
          queryCache.setQueryData('schedule', schedule => ({
            ...schedule,
            types: schedule.types.filter(type => type._id !== deletedType._id)
          }))
      }
      Alert.success(intl.formatMessage({ id: 'color.delete-success' }));
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  const columns = useMemo(
    () => [
      {
        Header: "Types",
        accessor: ({ _id, ...row }) => {
          return Object.values(row).join("|");
        },
        Cell: ({ cell: { value }, row: { original } }) => (
          // <pre>{JSON.stringify(original, null, 2)}</pre>
          <TypeRow
            key={original._id}
            id={original._id}
            name={original.name}
            icon={original.icon}
            deleteFn={(collection,_id) => {
              deleteTypeMutation({collection, _id })
            }}
          />
        ),
      },
    ],
    [deleteTypeMutation]
  );

  if (isLoading) {
    return <PageLoading />;
  }

  if (isError) {
    return <span>Error: {error.message}</span>
  }

  return (
    <React.Fragment>
      <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title="tab.schedule-types" />
      <div className="pad-2rem">
        <Container fluid>
          <Row className="align-items-center m-b-20">
            <Col md={6}>
              <CreateItemForm
                heading="button.s.type-create"
                setFunc={setTypeName}
                placeholder={intl.formatMessage({ id: 'button.s.type-create' })}
                link={`/type/add/${typeName}`}
              />
            </Col>
            <Col md={6}>
              <Row>
                <Col></Col>
                <Col md={5}>
                  <div className="text-right search-container">
                    <FormGroup>
                      <InputGroup onChange={(e) => setSearch(e.target.value)}>
                        <FormControl type="text" />
                        <InputGroup.Append>
                          <Button>
                            <img src="/icons/search.png" alt="plus" />
                          </Button>
                        </InputGroup.Append>
                      </InputGroup>
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <Table columns={columns} data={schedule.types} search={search} intl={intl} />
              {/* <pre>{JSON.stringify(schedule, null, 2)}</pre> */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};


export default injectIntl(Types);
